import { render, staticRenderFns } from "./GeoChart.vue?vue&type=template&id=4786abd6&scoped=true"
import script from "./GeoChart.vue?vue&type=script&lang=ts"
export * from "./GeoChart.vue?vue&type=script&lang=ts"
import style0 from "./GeoChart.vue?vue&type=style&index=0&id=4786abd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4786abd6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GChart: require('/home/runner/work/assessment-service/assessment-service/frontend/components/GChart.vue').default})
